import { FilterOption } from 'stores/types';

export default class FilterValueArray extends Array<FilterOption> {
  constructor(values: FilterOption[] | number) {
    // Base array class has 2 overloads
    // 1. Array(val, val, val) - when values is FilterOption[]
    // 2. Array(number) - when values is number (creates empty array of specified length)

    // This must exist to satisfy the base array class's overloads.
    // FilterValueArray.filter() will attempt to create a new array with the same length as the original array,
    // so we need to handle the case where values is a number.
    if (typeof values === 'number') {
      super(values);
    } else {
      // Sort items alphabetically by name for display, with id as tiebreaker for cache consistency
      const sortedValues = [...values].sort((a, b) => {
        const aName = a.name || String(a);
        const bName = b.name || String(b);
        const nameCompare = aName.localeCompare(bName);
        if (nameCompare !== 0) return nameCompare;
        // Tiebreaker by id ensures consistent ordering for cache keys
        const aId = a.id || '';
        const bId = b.id || '';
        return aId.localeCompare(bId);
      });
      super(...sortedValues);
    }
    Object.setPrototypeOf(this, FilterValueArray.prototype);
  }

  removeFilter(id: string) {
    return new FilterValueArray(this.filter((filterValue) => filterValue.id !== id));
  }

  serialize() {
    return this;
  }
}
